// extracted by mini-css-extract-plugin
export default {"text":"ProfileNameSettingsRow_text__r5h+p","editButton":"ProfileNameSettingsRow_editButton__QfC9d"};